import { createStore } from 'vuex';


import admin from './modules/admin/actionCreatore';
import website from './modules/website';




const store = createStore({
    modules: {
        admin,
        website,
    }
})

// store.subscribe((mutation, state) => {
// 	// Store the state object as a JSON string
// 	localStorage.setItem('adminStore', JSON.stringify(state));
// });
// store.subscribeAction({
//     before: (action, state) => {

        
//     },
//     after: (action, state) => {

//     }
// })

export default store
